import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import { DashboardLayout } from "../../Components/Layout/DashboardLayout";
import CustomTable from "../../Components/CustomTable";
import CustomModal from "../../Components/CustomModal";
import CustomPagination from "../../Components/CustomPagination";
import CustomInput from "../../Components/CustomInput";
import { useErrorBoundary } from "../../Hooks/useErrorBoundary";

import "./style.css";

export const UserManagement = () => {
  const { handleError } = useErrorBoundary();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [showModal3, setShowModal3] = useState(false);
  const [showModal4, setShowModal4] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 8;
  const [inputValue, setInputValue] = useState('');

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const inActive = () => {
    setShowModal(false);
    setShowModal2(true);
  };

  const ActiveMale = () => {
    setShowModal3(false);
    setShowModal4(true);
  };

  const handleChange = (e) => {
    setInputValue(e.target.value);
    setCurrentPage(1); // reset to page 1 on every new search
  };

  const handleClearSearch = () => {
    setInputValue('');
    setCurrentPage(1);
  };

  const trimmed = inputValue.trim().toLowerCase();

  const filterData = trimmed
    ? data.filter(
        (item) =>
          item?.name?.toLowerCase().includes(trimmed) ||
          item?.email?.toLowerCase().includes(trimmed)
      )
    : data;

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filterData.slice(indexOfFirstItem, indexOfLastItem);

  useEffect(() => {
    document.title = 'Virtual PI | User Management';
    const token = localStorage.getItem('login');
    const apiUrl = process.env.REACT_APP_BASE_URL;

    setLoading(true);
    setError(null);

    fetch(`${apiUrl}/admin/user`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => response.json())
      .then((res) => {
        if (res?.status) {
          setData(res.data ?? []);
        } else {
          setData([]);
        }
      })
      .catch((err) => {
        setError('Failed to load users. Please try again.');
        handleError(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const maleHeaders = [
    { key: "id",     title: "S.No"          },
    { key: "name",   title: "Name"          },
    { key: "email",  title: "Email Address" },
    { key: "action", title: "Action"        },
  ];

  const renderBody = () => {
    // API still loading
    if (loading) {
      return (
        <tbody>
          <tr>
            <td colSpan={maleHeaders.length} className="text-center py-4 text-muted">
              Loading users...
            </td>
          </tr>
        </tbody>
      );
    }

    // API call failed
    if (error) {
      return (
        <tbody>
          <tr>
            <td colSpan={maleHeaders.length} className="text-center py-4 text-danger">
              {error}
            </td>
          </tr>
        </tbody>
      );
    }

    // API returned no users at all
    if (data.length === 0) {
      return (
        <tbody>
          <tr>
            <td colSpan={maleHeaders.length} className="text-center py-4 text-muted">
              No users found.
            </td>
          </tr>
        </tbody>
      );
    }

    // Search returned no matches
    if (filterData.length === 0) {
      return (
        <tbody>
          <tr>
            <td colSpan={maleHeaders.length} className="text-center py-4 text-muted">
              No users match &ldquo;{inputValue}&rdquo;.
            </td>
          </tr>
        </tbody>
      );
    }

    // Normal render
    return (
      <tbody>
        {currentItems.map((item, index) => (
          <tr key={item?.id ?? index}>
            <td>{indexOfFirstItem + index + 1}</td>
            <td className="text-capitalize">{item?.name}</td>
            <td>{item?.email}</td>
            <td>
              <Link to={`/user-detail/${item?.id}`} className="btn btn-dark py-1">
                View
              </Link>
            </td>
          </tr>
        ))}
      </tbody>
    );
  };

  return (
    <>
      <DashboardLayout>
        <div className="container-fluid">
          <div className="row mb-3">
            <div className="col-12">
              <div className="dashCard">
                <div className="row mb-3 justify-content-between align-items-center">
                  <div className="col-md-6 mb-2">
                    <h2 className="mainTitle">User Management</h2>
                  </div>
                  <div className="col-md-4 mb-2">
                    <div className="addUser position-relative">
                      <CustomInput
                        type="text"
                        placeholder="Search by name or email..."
                        value={inputValue}
                        inputClass="mainInput"
                        onChange={handleChange}
                      />
                      {inputValue && (
                        <button
                          type="button"
                          onClick={handleClearSearch}
                          className="btn-close position-absolute"
                          style={{ top: '50%', right: '10px', transform: 'translateY(-50%)', fontSize: '0.65rem' }}
                          aria-label="Clear search"
                        />
                      )}
                    </div>
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-12">
                    <CustomTable headers={maleHeaders}>
                      {renderBody()}
                    </CustomTable>

                    {!loading && !error && filterData.length > itemsPerPage && (
                      <CustomPagination
                        itemsPerPage={itemsPerPage}
                        totalItems={filterData.length}
                        currentPage={currentPage}
                        onPageChange={handlePageChange}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <CustomModal show={showModal}  close={() => setShowModal(false)}  action={inActive}   heading="Are you sure you want to mark this user as inactive?" />
          <CustomModal show={showModal2} close={() => setShowModal2(false)} success heading="Marked as Inactive" />
          <CustomModal show={showModal3} close={() => setShowModal3(false)} action={ActiveMale} heading="Are you sure you want to mark this user as Active?" />
          <CustomModal show={showModal4} close={() => setShowModal4(false)} success heading="Marked as Active" />
        </div>
      </DashboardLayout>
    </>
  );
};
